import { string, object } from 'prop-types'
import { connect } from 'react-redux'
import { assetProxyImageUrl } from '@opallabs/routing'
import { actions, jsonApiWrapper } from '@opallabs/wormhole'
import ImageSlide from './ImageSlide'
import TextImageSlide from './TextImageSlide'
import TextSlide from './TextSlide'

const ConnectedSlideComponent = (props) => {
  const { layout } = props

  const theme = props.theme === null ? {} : props.theme
  const sanitizedProps = { ...props, theme }

  switch (layout) {
    case 'image_only':
      return <ImageSlide {...sanitizedProps} />
    case 'basic_text':
    case 'section_header':
      return <TextSlide {...sanitizedProps} />
    case 'text_and_image':
      return <TextImageSlide {...sanitizedProps} />
    default:
      return null
  }
}

ConnectedSlideComponent.propTypes = {
  layout: string,
  theme: object,
}

const mapStateToProps = (state, props) => {
  let additionalProps

  if (state.jsonApiEntities && state.jsonApiEntities.slide) {
    const slide = state.jsonApiEntities.slide[props.slideId]
    const { canvas_asset_reference, background_asset_reference } =
      jsonApiWrapper({ data: slide, state }) || {}
    let backgroundImageUrl

    if (background_asset_reference && background_asset_reference.uuid) {
      backgroundImageUrl = assetProxyImageUrl({
        uuid: background_asset_reference.uuid,
      })
    }

    additionalProps = {
      ...slide,
      assetReference: canvas_asset_reference || props.assetReference,
      backgroundImageURL: backgroundImageUrl || props.backgroundImageURL || '',
    }
  }

  return additionalProps || {}
}

const mapDispatchToProps = (dispatch) => ({
  getSlide: (presentationId, slideId) => {
    dispatch(actions.getSlide(presentationId, slideId))
  },
  uploadAsset: (params) => dispatch(actions.handleAssetUploadV2(params)),
  updateSlide: (presentationId, slideId, changes) => {
    dispatch(actions.updateSlide(presentationId, slideId, changes))
  },
})

const ConnectedSlide = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedSlideComponent)

export default ConnectedSlide
